import { Box, Paper } from '@mui/material';

const PdfView = () => {
  return (
    <Paper sx={{ p: 2, height: '100vh' }}>
      <Box
        component="iframe"
        src="https://incrypt-public-assets-global.s3.ap-southeast-2.amazonaws.com/documents/SOS_Privacy_Policy_Mature.pdf"
        sx={{
          width: '100%',
          height: '100%',
          border: 'none',
          borderRadius: 2
        }}
      />
    </Paper>
  );
};

export default PdfView;
